import { Component, Input, OnInit } from '@angular/core';
import { RespuestasRapidasService } from 'src/app/services/respuestas-rapidas.service';

@Component({
  selector: 'app-mdl-res-encuestas',
  templateUrl: './mdl-res-encuestas.page.html',
  styleUrls: ['./mdl-res-encuestas.page.scss'],
})
export class MdlResEncuestasPage implements OnInit {

  @Input() respuesta: any;
  @Input() user: any;
  datos: any;
  constructor(
    private encuestaService: RespuestasRapidasService
  ) { 
    this.datos = [];
  }

  ngOnInit() {
    // console.log(this.respuesta);
    this.getRespuestas();
  }

  getRespuestas() {
    this.encuestaService.resultadoEncuestas(this.user.canale.idAdmin_sec, this.user.id, this.user.rol, this.user.token, this.respuesta.unique_encuesta, this.user.canale.url_back).subscribe((res: any) =>{
      console.log(res)
      if(res.status == 'success') {
        // const [resultados] = res;
        this.datos = res.resultados;
      }
    },
    err => {
      console.log(err);
    });
  }

}
